import React from 'react';

import { FieldTypes } from '../FormLogs';
import FormRow from "../../../Components/HorizontalForm/FormRow";
import HtmlField from './HtmlField';
import HtmlSubFormField from "./FormlogFields/HtmlSubFormField";

const HtmlForm = (props) => {

    const getError = (field) => {
        let errorKey = `form.${field.id}`;
        if (props.errors && props.errors[errorKey]) {
            return props.errors[errorKey];
        }
        return '';
    }

    const getValue = (field) => {
        if (props.values && props.values[field.id]) {
            return props.values[field.id];
        }

        if (FieldTypes.TYPE_FILEUPLOAD === field.type) {
            return [];
        }

        if ([FieldTypes.TYPE_CHECKBOX, FieldTypes.TYPE_T_AND_C].includes(field.type)) {
            return false;
        }
        return '';
    }

    /**
     * Send the entire form state up on change
     * @param field
     * @param value
     */
    const handleChange = (field, value) => {
        const currentValues = (props.values) ? {...props.values} : {};
        const updatedValues = {
            ...currentValues,
            [field]: value
        }

        props.onChange(updatedValues);
    }

    const shouldShowSubForm = (field) => {
        if (field.type !== FieldTypes.TYPE_CHECKBOX
            || !field.hasOwnProperty('subFields')
        ) {
            return false;
        }

        return (getValue(field) === true);
    }

    return (<>
        { props.fields.map(field => {
            return (<React.Fragment key={field.id}>
                <FormRow
                    label={field.type === FieldTypes.TYPE_CONTENT ? '' : field.label}
                    infoMessage={field.type === FieldTypes.TYPE_T_AND_C ? '' : field.text}
                    errorMessage={getError(field)}
                    required={(field.validations == 'required')}
                    leftCellClassName="small-12 medium-3"
                    rightCellClassName="small-12 medium-9 custom-form-cell"
                >
                    <HtmlField
                        field={field}
                        onBlur={props.onBlur}
                        onChange={handleChange}
                        value={getValue(field)}
                    />
                </FormRow>

                {(shouldShowSubForm(field)) && (
                    <HtmlSubFormField
                        form={props.form}
                        field={field}
                        errors={props.errors}
                        onChange={props.onChange}
                        values={props.values}
                    />
                )}
            </React.Fragment>)
        })}
    </>);
}

HtmlForm.defaultProps = {
    columns: 1,
    onBlur: () => {},
    onChange: () => {},
    errors: null,
}

export default HtmlForm;
